/**************************************************
 * Nombre:       Tarjeta_Detalle_Descripcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Detalle_Descripcion = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={item.largo} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 9, sm: 9, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600, fontSize: 18, lineHeight: 1.1}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontWeight: 400, fontSize: 14}}>{item.descripcion}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Detalle_Descripcion